import { Input, message, Modal } from "antd";
import React, { Component } from "react";
import withRouter from "../withRouter";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import SosAlertStore from "../store/SosAlertStore";
import MapForVehiclePosition from "./MapForVehiclePosition";

class SosAlertNotification extends Component {
    constructor(props, context) {
        super(props);
        this.sosAlertStore = new SosAlertStore(this);

        this.state = {
            notifications: [],
            showStatusConfirm: false,
            comment: "",
            vehicleObj: false
        };
    }

    componentDidMount() {
        console.log("this.props", this.props)
        this.loadNotifications(this.props.notifyData);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.notifyData !== this.props.notifyData) {
            this.loadNotifications(this.props.notifyData);
        }
    }

    loadNotifications = (notifyData) => {
        const { user } = this.props;

        if (!notifyData || notifyData.length === 0) return;


        const activeNotifications = notifyData.filter(n => !n.dismiss);

        // Limit to 16
        const limited = activeNotifications.slice(0, 12);

        this.setState({
            notifications: limited
        });
    };

    handleLocationClick = (latitude, longitude) => {
        if (!latitude || !longitude) {
            alert("Location not available");
            return;
        }

        if (this.props.onShowLocation) {
            this.props.onShowLocation(latitude, longitude);
        }
    };

    handleClose = (rlId) => {
        // const comment = window.prompt("Please enter your comments:");
        this.setState({ showStatusConfirm: true, rlId: rlId })

    };
    dismissAlert = async () => {
        const rlId = this.state.rlId;
        // this.setState({ showStatusConfirm: false })
        const data = {
            Id: rlId,
            textInput: this.state.comment,
            userId: this.props.getUserData().userId,
        }

        const res = await this.sosAlertStore.dismissSosAlert(data);
        if (res.data.success) {
            this.setState({ showStatusConfirm: false, comment: "" })
            message.success("Alert dismissed successfully");
        }
        await this.props.getSOSAlert()
        this.setState({ loadData: 1 })
    }
    handleConfirm = () => {
        const { comment } = this.state;

        if (!comment || comment.trim() === "") {
            this.setState({
                commentError: "Comment is required"
            });
            return;
        }

        // clear error
        this.setState({ commentError: "" });

        // call original function
        this.dismissAlert();
    };
    render() {
        const { notifications } = this.state;

        if (!notifications.length) return null;

        return (<>
            <div className="sos-notification-container">
                {notifications.map((data) => (
                    <div key={data.Id} className="sos-notification-card">

                        {/* Header */}
                        <div className="sos-notification-header">
                            <span>Notification</span>
                            <span
                                className="notification-close"
                                onClick={() => this.handleClose(data.Id)}
                            >
                                ×
                            </span>
                        </div>

                        {/* Body */}
                        <div className="sos-notification-body">
                            <div><strong>Vehicle No:</strong> {data.vehicleNo}</div>
                            <div><strong>Driver Name:</strong> {data.driverName}</div>
                            <div><strong>Datetime:</strong> {data.dateTime}</div>
                            <div><strong>Panic Type:</strong> {data.panicType}</div>
                            <div>
                                <strong>Address:</strong>{" "}
                                <div>
                                    <span
                                        className={
                                            data.latitude
                                                ? "sos-notification-link active sos-address-text"
                                                : "sos-notification-link disabled sos-address-text"
                                        }
                                        title={data.location}   // 👈 full address on hover
                                        onClick={async () => {
                                            await this.setState({
                                                vehicleObj: { ...data, icon: "logo_icon.png" },
                                                heading: this.context.translate("_LOCATION_ON_MAP_"),
                                            });
                                        }}
                                    >
                                        {data.location || "-"}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <Modal
                maskClosable={false}
                title="Comment"
                centered
                open={this.state.showStatusConfirm}
                onOk={this.handleConfirm}
                onCancel={() => {
                    this.setState({ showStatusConfirm: false, commentError: "" });
                }}
                width={400}
            >
                <Input.TextArea
                    rows={1}
                    value={this.state.comment}
                    onChange={(e) =>
                        this.setState({
                            comment: e.target.value,
                            commentError: ""
                        })
                    }
                    status={this.state.commentError ? "error" : ""}
                />

                {this.state.commentError && (
                    <div style={{ color: "red", marginTop: 5, fontSize: 12 }}>
                        {this.state.commentError}
                    </div>
                )}
            </Modal>

            {this.state.vehicleObj && (
                <MapForVehiclePosition
                    showLiveTrackingMap={true}
                    vehicleObj={this.state.vehicleObj}
                    heading={this.state.heading}
                    closeMapModal={(resp) => {
                        this.setState({ vehicleObj: resp });
                    }}
                />
            )}
        </>

        );
    }
}
SosAlertNotification.contextType = StoreContext;
export default observer(withRouter(SosAlertNotification));

// export default SosAlertNotification;